import {
    createContext, useState, useCallback, useMemo,
} from "react";
import SnackbarToast from "../../components/SnackbarToast";

export const ToastContext = createContext();

let toastId = 0;

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, []);

    const addToast = useCallback((message, options = {}) => {
        // eslint-disable-next-line no-plusplus
        const id = ++toastId;
        const newToast = {
            id,
            message,
            open: true,
            ...options,
        };

        setToasts((prev) => [...prev, newToast]);

        // Auto-remove toast after duration
        const duration = options.autoHideDuration || 5000;
        setTimeout(() => {
            removeToast(id);
        }, duration);

        return id;
    }, []);

    const toast = useMemo(() => ({
        show: (message, options) => addToast(message, options),
        success: (message, options = {}) => addToast(message, { ...options, isSuccess: true }),
        error: (message, options = {}) => addToast(message, { ...options, isError: true }),
        info: (message, options = {}) => addToast(message, options),
        warning: (message, options = {}) => addToast(message, { ...options, isWarning: true }),
    }), [addToast]);

    return (
        <ToastContext.Provider value={toast}>
            {children}
            {toasts.map((toast) => (
                <SnackbarToast
                    key={toast.id}
                    open={toast.open}
                    onClose={() => removeToast(toast.id)}
                    isSuccess={toast.isSuccess}
                    isError={toast.isError}
                    isWarning={toast.isWarning}
                    autoHideDuration={toast.autoHideDuration}
                >
                    {toast.message}
                </SnackbarToast>
            ))}
        </ToastContext.Provider>
    );
};
